import { createStore, useStore } from 'zustand';

export type ImagePreviewState = {
  previewUrls: Record<string, Record<string, string>>;
  setPreviewUrl: (locale: string, path: string, url: string) => void;
  clearPreviewUrl: (locale: string, path: string) => void;
};

const imagePreviewStore = createStore<ImagePreviewState>()((set) => ({
  previewUrls: {},
  setPreviewUrl: (locale, path, url) =>
    set((state) => {
      const perLocale = state.previewUrls[locale] || {};
      return {
        previewUrls: {
          ...state.previewUrls,
          [locale]: { ...perLocale, [path]: url },
        },
      };
    }),
  clearPreviewUrl: (locale, path) =>
    set((state) => {
      const perLocale = state.previewUrls[locale];
      if (!perLocale) return state;
      const { [path]: removedEntry, ...restPaths } = perLocale;
      return {
        previewUrls: {
          ...state.previewUrls,
          [locale]: restPaths,
        },
      };
    }),
}));

export const useImagePreviewUrl = (locale: string, path: string) =>
  useStore(imagePreviewStore, (s) => s.previewUrls[locale]?.[path]);

export const useImagePreviewActions = () =>
  useStore(imagePreviewStore, (s) => ({
    setPreviewUrl: s.setPreviewUrl,
    clearPreviewUrl: s.clearPreviewUrl,
  }));
